export type RuntimeConfig = {
  API_URL: string;
  IED_API_URL: string;
  Keycloak_URL: string;
  Keycloak_Realm: string;
  Keycloak_ClientId: string;
  HIDE_MENU: string;
  WFX_API_BASE_URL: string;
  WFX_AUTH_ENABLED: string;
};

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: Partial<RuntimeConfig>;
  }
}

export function getRuntimeConfig(): RuntimeConfig {
  const runtime = typeof window !== 'undefined' ? window.__RUNTIME_CONFIG__ : undefined;

  return {
    API_URL: runtime?.API_URL ?? API_URL,
    IED_API_URL: runtime?.IED_API_URL ?? IED_API_URL,
    Keycloak_URL: runtime?.Keycloak_URL ?? Keycloak_URL,
    Keycloak_Realm: runtime?.Keycloak_Realm ?? Keycloak_Realm,
    Keycloak_ClientId: runtime?.Keycloak_ClientId ?? Keycloak_ClientId,
    HIDE_MENU: runtime?.HIDE_MENU ?? HIDE_MENU,
    WFX_API_BASE_URL: runtime?.WFX_API_BASE_URL ?? WFX_API_BASE_URL,
    WFX_AUTH_ENABLED: runtime?.WFX_AUTH_ENABLED ?? WFX_AUTH_ENABLED,
  };
}

export function isHideMenu(): boolean {
  // Must read window at runtime; Mako folds `HIDE_MENU === 'true'` to constant true at build time.
  if (typeof window !== 'undefined') {
    const runtimeValue = window.__RUNTIME_CONFIG__?.HIDE_MENU;
    if (runtimeValue !== undefined) {
      return runtimeValue === 'true';
    }
  }
  return HIDE_MENU === 'true';
}

export function isWfxAuthEnabled(): boolean {
  // Must read window at runtime; Mako folds string compares to constants at build time.
  if (typeof window !== 'undefined') {
    const runtimeValue = window.__RUNTIME_CONFIG__?.WFX_AUTH_ENABLED;
    if (runtimeValue !== undefined) {
      return runtimeValue === 'true';
    }
  }
  return WFX_AUTH_ENABLED === 'true';
}
